import { Box, Stack, Tab, TabList, TabPanel, TabPanels, Tabs, useBreakpointValue } from "@chakra-ui/react";
import { useIsMainAppLoading, useTabProps } from "hooks";
import type { FunctionComponent } from "react";
import React, { useContext, useState } from "react";
import { ContentFilterContext } from "screens/content";
import { CompanyDetailDefaultActionMenu } from "./CompanyDetailDefaultViewActionMenu";
import { CompanyDetailViewDashboardTab } from "./DetailViewTabs/CompanyDetailViewDashboardTab";
import { CompanyDetailViewFinancialsTab } from "./DetailViewTabs/CompanyDetailViewFinancialsTab";
import { CompanyDetailViewInvestmentTab } from "./DetailViewTabs/CompanyDetailViewInvestmentTab";
import { CompanyDetailViewCompanyTab } from "./DetailViewTabs/CompanyDetailViewCompanyTab";

interface Props {
  collectionId: string;
}

export const CompanyDetailViewContent: FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({ collectionId }) => {
  const { resetFilter } = useContext(ContentFilterContext);
  const [tabIndex, setTabIndex] = useState(0);
  const { defaultTabProps } = useTabProps();
  const isMainAppLoading = useIsMainAppLoading();
  const isMobile = useBreakpointValue({ base: true, md: false }, { fallback: "md", ssr: false });

  const handleTabsChange = (index: number) => {
    setTabIndex(index);
    resetFilter();
  };

  return (
    <>
      {!isMainAppLoading && (
        <Tabs isFitted={isMobile} index={tabIndex} onChange={handleTabsChange}>
          <Stack direction="row" justifyContent={"space-between"} width="100%" spacing=".5rem" pb=".5rem" align="center">
            <TabList borderBottom={"none"} flex="1">
              <Tab {...defaultTabProps} width={isMobile ? "100%" : "9rem"} className="ch-company-dashboard">
                Dashboard
              </Tab>
              <Tab {...defaultTabProps} width={isMobile ? "100%" : "9rem"} className="ch-company-details">
                Company
              </Tab>
              <Tab {...defaultTabProps} width={isMobile ? "100%" : "9rem"} className="ch-company-financials">
                Financials
              </Tab>
              <Tab {...defaultTabProps} width={isMobile ? "100%" : "9rem"} className="ch-company-investment">
                Investment
              </Tab>
              <Tab {...defaultTabProps} width={isMobile ? "100%" : "9rem"} className="ch-company-data-room">
                Data Room
              </Tab>
            </TabList>
            <Box width="6rem">
              <CompanyDetailDefaultActionMenu collectionId={collectionId} />
            </Box>
          </Stack>
          <TabPanels pb="4rem">
            <TabPanel pt=".65rem" px="0!important" className="ch-company-dashboard-panel">
              <CompanyDetailViewDashboardTab collectionId={collectionId} isLoading={isMainAppLoading} />
            </TabPanel>
            <TabPanel pt=".65rem" px="0!important" className="ch-company-details-panel">
              <CompanyDetailViewCompanyTab collectionId={collectionId} isLoading={isMainAppLoading} />
            </TabPanel>
            <TabPanel pt=".65rem" px="0!important" className="ch-company-financials-panel">
              <CompanyDetailViewFinancialsTab collectionId={collectionId} isLoading={isMainAppLoading} />
            </TabPanel>
            <TabPanel pt=".65rem" px="0!important" className="ch-company-investment-panel">
              <CompanyDetailViewInvestmentTab collectionId={collectionId} isLoading={isMainAppLoading} />
            </TabPanel>
            <TabPanel pt=".65rem" px="0!important" className="ch-company-data-room-panel">
              TBD
            </TabPanel>
          </TabPanels>
        </Tabs>
      )}
    </>
  );
};
